export const dataHooks = {
  errorMessageWrapper: 'error-message-wrapper',
};
